import React, {useEffect, useRef, useState} from 'react';

import {useHistory} from "react-router-dom";
import {callApi} from "../../../connection/ClientApi";

import Urls from "../../../connection/Urls";

import messages from "res/messages/farsi";

import {
    IsF,
   IsLP_MP_SP,
    IsLP_MP_SP_T,
    IsT
} from "my-styles/media/media";

import ICComment from "res/images/comment.png";
import TitleAddHeader from "../address/TitleAddHeader";
import ICBackIcon from "res/images/back.png";

import ICEdit from "res/images/edit.png";

import Space from "components/space/Space";
import IconTitleValue from "components/textValue/IconTitleValue";

import getColorByOrderStatus from "../order/OrderUtility";

import ICCalender from "res/images/calendar.png";

import ThumbnailGellery from "components/thumbnailGallery/ThumbnailGellery";

import ModalAnsweTicketCard from "./../../../components/modal/ModalAnsweTicketCard";
import {Helmet} from "react-helmet";

export default function TicketDetail(props) {

    const history = useHistory();

    const urlParams = props.location;

    const  [getTicket,setTicket]=useState([]);
    const [getCommentTicket,setCommentTicket]=useState([]);


    useEffect(() => {
        requestGetTicket()
    }, [])


    const requestGetTicket=()=>{
        let ticket_id = (props.location.state ? props.location.state.ticket_id : undefined);
        let params = new FormData();
        params.append("ticket_id", ticket_id);

        callApi(Urls.getTicketDetail, params, (data) => {
            if (data) {
                setTicket(data);
                setCommentTicket(data.comments);
            }
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }


    const ChatBox = () => {

        return (
            <div className="chat-box">
                   <span style={{margin:'1rem auto'}}>
                              { <ModalAnsweTicketCard {...props} ticket={getTicket} />}
                        </span>
                {getCommentTicket.map((message, index) => (
                    <div
                        key={index}
                        className={`message ${message.user == 0 ? 'user' : 'admin'}`}
                    >
                        {message.user == 0 && (
                            <div className="">
                                <div>
                                    <div className="message-info">
                                        <span className="user-name">{message.name}</span>
                                        <span className="message-date">{message.dataShamsi}</span>
                                    </div>
                                    <div className="message-info">
                                        <span className="message-date">{message.message}</span>
                                    </div>
                                </div>
                                {message.voice && (
                                    <audio controls src={message.voice} className="styleAdiorecord" style={{height:'2.5rem'}}  />
                                )}
                                {message.images.length> 0 && (
                                    <div className="horizontalFullScreen " style={{marginTop:'1rem',width:'14rem'}}>
                                        <div className="card marginSmall  widthResponsiveCardImage ">
                                            <div className="marginSmall">
                                                <ThumbnailGellery
                                                    key={Math.random()}
                                                    itemPerView={IsT() ? 3 : 4}
                                                    items={message.images}/>
                                            </div>
                                        </div>
                                    </div>
                                )
                                }

                            </div>
                        )}
                        {message.user> 0 && (
                            <div className="">
                                <div>
                                    <div className="message-info">
                                        <span className="user-name">{message.name}</span>
                                        <span className="message-date">{message.dataShamsi}</span>
                                    </div>
                                    <div className="message-info">
                                        <span className="message-date">{message.message}</span>
                                    </div>
                                </div>
                                {message.voice && (
                                    <audio controls src={message.voice} className="styleAdiorecord" style={{height:'2.5rem'}} />
                                )}
                                {message.images.length> 0 && (
                                    <div className="horizontalFullScreen " style={{marginTop:'1rem',width:'14rem'}}>
                                        <div className="card marginSmall  widthResponsiveCardImage ">
                                            <div className="marginSmall">
                                                <ThumbnailGellery
                                                    key={Math.random()}
                                                    itemPerView={IsT() ? 3 : 4}
                                                    items={message.images}/>

                                            </div>
                                        </div>
                                    </div>
                                )
                                }
                            </div>
                        )}
                    </div>
                ))}
            </div>
        );
    };



    return (
        <>
            <Helmet>
                <title>ØµØ±ÙÙ ÙØ§Ø±Ú©Øª - Ø¬Ø²Ø¦ÛØ§Øª ØªÛÚ©Øª</title>
                <meta property="og:image" content="%PUBLIC_URL%/favicon.ico" />
                <meta property="og:url" content="https://sarfemarket.ir/" />
            </Helmet>
            {getTicket &&
            <div className="wInLPT100_wInFMS95">

                <div className="marginTopBottomSmall">
                    <TitleAddHeader
                        icon={ICBackIcon}
                        title={messages.ticketDetail}
                        onIconClick={() => {
                            props.onNavigate(history,
                                '/suggestion')
                        }}/>
                </div>

                <div className="hInLPT_vInFMS">
                    <div style={IsLP_MP_SP_T() ? {minHeight: "50em"} : {minHeight: "17em"}}
                         className="card marginLeftRightSmall wInLP32_wInT43_wInFMS100">
                        <Space height={"1em"}/>
                        <div
                            className={IsLP_MP_SP() ? "halfWidth" :
                                IsT() ? "" :
                                    IsF() ? "" : "halfWidth"} style={{width:'10rem'}}>
                            <div className="card_blue_left_curve_ticket" style={{padding: "0.5px"}}>
                                <IconTitleValue
                                    valueClassName={"whiteColor"}
                                    titleClassName={"whiteColor"}
                                    title={messages.orderId}
                                    value={getTicket.id}/>


                            </div>
                        </div>
                        <Space height={"1em"}/>

                      <div style={{marginRight:'0.7rem',marginLeft:'0.7rem'}}>
                          <IconTitleValue
                              icon={<img src={ICCalender} alt="ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"  className="xxSmallIcon"/>}
                              title={messages.RegistrationDate}
                              value={getTicket.dataShamsi} />
                          <IconTitleValue
                              valueClassName={getColorByOrderStatus(1)}
                              icon={<img src={ICEdit} alt="ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"  className="xxSmallIcon"/>}
                              title={messages.subject}
                              value={getTicket.subject}/>

                          <IconTitleValue
                              valueClassMessage="boxMassageShow "
                              icon={<img src={ICComment} alt="ØµØ±ÙÙ ÙØ§Ø±Ú©Øª" className="xxSmallIcon"/>}
                              title={messages.messageDescription}
                              value={getTicket.ticket_message}/>
                      </div>

                        <Space/>

                        <div style={{float: "left",width:'10rem'}}
                             className={IsLP_MP_SP() ? "halfWidth" :
                                 IsT() ? "" :
                                     IsF() ? "" : "halfWidth"} >
                            <div style={{padding: "0.5px"}}
                                 className={getTicket.status_type===0 ? "card_light_blue_right_curve_ticket marginTopBottomSmall fullWidth" :"card_green_right_curve_ticket marginTopBottomSmall fullWidth"}>
                                <IconTitleValue
                                    valueClassName={"whiteColor"}
                                    titleClassName={"whiteColor"}
                                    value={getTicket.status}/>
                            </div>

                        </div>
                        {getTicket.voice_url && (
                          <div style={{display:'flex',justifyContent:'center',width:'100%'}}>
                              <audio controls src={getTicket.voice_url} className="styleAdiorecord" style={{width:'85%',height:'2.5rem'}} />
                          </div>
                        )}
                        {getTicket.images && getTicket.images.length>0 &&
                            ( <div className="horizontalFullScreen marginTopSmall">
                                    <div className="card marginSmall  widthResponsiveCardImage ">
                                        <div className="marginSmall">
                                            <ThumbnailGellery
                                                key={Math.random()}
                                                itemPerView={IsT() ? 3 : 4}
                                                items={getTicket.images}/>
                                        </div>
                                    </div>
                                </div>
                            )
                        }

                        <Space/>


                    </div>
                    <div style={{width:'100%',marginTop:'1rem',marginRight:'0.5rem'}}>
                    <span>
                       {ChatBox()}
                    </span>

                    </div>

                </div>
            </div>


        }</>

    )

}